import actions from "./actions";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  isFetching: false,
  successMessage: "",
  errorMessage: "",
  actionType: "",
  status_code: 0,
});

export default function schoolReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SCHOOL_CREATE_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
        actionType: actions.SCHOOL_CREATE_REQUEST,
      });
    case actions.SCHOOL_CREATE_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.SCHOOL_CREATE_SUCCESS,
        successMessage: action.message,
        status_code: action.status_code,
      });
    case actions.SCHOOL_CREATE_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.SCHOOL_CREATE_ERROR,
        errorMessage: action.error,
      });

    case actions.STUDENT_CREATE_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
        actionType: actions.STUDENT_CREATE_REQUEST,
      });

    case actions.STUDENT_CREATE_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.STUDENT_CREATE_SUCCESS,
        successMessage: action.message,
        status_code: action.status_code,
      });

    case actions.STUDENT_CREATE_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: actions.STUDENT_CREATE_ERROR,
        errorMessage: action.error,
      });

    case actions.RESET_ACTIONTYPE:
      return Immutable.merge(state, {
        actionType: "",
        successMessage: "",
        errorMessage: "",
        isFetching: false,
      });
    default:
      return state;
  }
}
